<div class="text-center preview-container">
  <img
    [src]="website.preview"
    [alt]="website.name"
    class="img-fluid rounded"
    [class.fade-in]="fade"
    priority
  />
</div>
